export const PHONE_REGEX = /^[+]?[0-9]{1,15}$/

export const URL_MAX_LENGTH = 500

export const EMAIL_MAX_LENGTH = 254

export const EMAIL_REGEX =
	/^[a-zA-Z0-9!#$%&'*+/=?^_{|}~`-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~`-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/

export const POSTAL_CODE_REGEX =
	/^(?!.* .* )[a-zA-Z0-9](?:[a-zA-Z0-9 ]|-(?=[a-zA-Z0-9])){0,13}[a-zA-Z0-9]$/

export const CARD_HOLDER = /^(?:[A-Za-z]+ ?){1,3}$/gm

export const PHONE_MAX_LENGTH = 16

export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 100

export const PASSWORD_REGEX =
	/^(?=.*?[a-zA-Z])(?=.*?[0-9])[A-Za-z\d@$!%*|?&+=#^{}:;"'<,.>/№`~\-_]{8,100}$/

export const QR_PASSWORD_MIN_LENGTH = 6
export const QR_PASSWORD_MAX_LENGTH = 64

export const COMPANY_FIELDS_MAX_LENGTH = 200
export const TITLE_MAX_LENGTH = 100
export const DESCRIPTION_MAX_LENGTH = 250
export const NAME_MAX_LENGTH = 50
export const FRAME_TEXT_MAX_LENGTH = 30
